import { useMemo } from 'react';
import useSWR from 'swr';

import { cheryInstance } from '@/api';

export type TFeedbackReasonData = {
  Descr: string;
  DirectionId: number;
  ReasonId: number;
  TypeId: number;
};

export type TFeedbackTypeData = {
  Descr: string;
  DirectionId: number;
  FeedbackReasonList?: TFeedbackReasonData[];
  IsReasonReqired: boolean;
  TypeId: number;
};

export type TDirectionData = {
  Descr: string;
  DirectionId: number;
  FeedbackTypeList: TFeedbackTypeData[];
};

export type TFeedbackReason = {
  id: number;
  title: string;
};

export type TFeedbackType = {
  id: number;
  title: string;
  reasons: TFeedbackReason[];
};

export type TDirection = {
  id: number;
  title: string;
  types: TFeedbackType[];
};

const getTopics = async endpoint => {
  const { data } = await cheryInstance.get<TDirectionData[]>(endpoint);
  return data;
};

const useDirectionLSDataFetch = () => {
  const { data: directionData, error } = useSWR(`feedback/index.json`, getTopics);

  const directions = useMemo(() => {
    const directions = directionData || [];
    return directions.reduce((acc, { DirectionId, Descr, FeedbackTypeList }) => {
      const direction: TDirection = {
        id: DirectionId,
        title: Descr,
        types: FeedbackTypeList.map(type => {
          return {
            id: type.TypeId,
            title: type.Descr,
            reasons:
              !type.IsReasonReqired || !type.FeedbackReasonList
                ? []
                : type.FeedbackReasonList.map(reason => ({
                    id: reason.ReasonId,
                    title: reason.Descr,
                  })),
          };
        }),
      };
      return [...acc, direction];
    }, [] as TDirection[]);
  }, [directionData]);

  const getFeedbackTypes = directionId => {
    if (!directionId) return [];
    return directions.find(d => d.id === directionId)?.types || [];
  };

  const getFeedbackReasons = (directionId, typeId) => {
    if (!directionId || !typeId) return [];
    return getFeedbackTypes(directionId).find(t => t.id === typeId)?.reasons || [];
  };

  return {
    data: { directions },
    loading: !directionData,
    error,
    getFeedbackTypes,
    getFeedbackReasons,
  };
};

export default useDirectionLSDataFetch;
